import { Formik, Form, Field, ErrorMessage, useFormikContext, useField } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import CustomPhoneField from "../../../Layout/Common/customPhoneField";
import { Fragment, useState } from "react";
import { FormikErrorMessage } from "../../../Layout/Common/fromikErrorMessage";

export const RequestMailDownloadForm = ({ onSubmit, hasAttachment }) => {
  const [initialValues, setInitialValues] = useState({
    fullName: "",
    phoneNumber: "",
    question: "",
  });

  const [submitclicked, setSubmitclicked] = useState(false);

  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    phoneNumber: Yup.string().matches(/^\d+$/, { message: "Must be a number", excludeEmptyString: true }),
    question: Yup.string().max(300, "Maximum 300 characters").required("Question is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setSubmitclicked(true);
    await onSubmit({
      fullName: values.fullName,
      phone: values.phoneNumber,
      queries: values.question,
    });
    resetForm();
    setSubmitclicked(false);
  };

  const handleCancelClick = (resetForm) => {
    $("#requestDownloads").slideToggle("slow");
    $("#listofProduct").slideToggle("slow");
    resetForm(initialValues);
    setSubmitclicked(false);
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({ setFieldValue, errors, isValid, touched, values, resetForm, ...formik }) => (
        <Form>
          <div className="row">
            <div className="col-sm-12 col-lg-12">
              <div className="row">
                <div className="col-sm-6 col-lg-6">
                  <div className="row">
                    <div className="col-sm-12 col-lg-12">
                      <div className="mt-3 question-form">
                        <label htmlFor="fullName" className="form-label">
                          Full Name <span>*</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control"
                          id="fullName"
                          name="fullName"
                          placeholder="Enter Full Name"
                        />
                        <ErrorMessage name="fullName">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                      </div>

                      <div className="mt-3 question-form">
                        <label htmlFor="phoneNumber" className="form-label">
                          Phone Number
                        </label>
                        <Field
                          name="phoneNumber"
                          id="phoneNumber"
                          component={CustomPhoneField}
                          className="form-control"
                          placeholder="Enter Phone Number"
                        />
                        <ErrorMessage name="phoneNumber">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-lg-6 questionForm-rht">
                  <div className="mt-3 question-form">
                    <label htmlFor="question" className="form-label">
                      Download Required / Comments <span>*</span>
                    </label>
                    <Field
                      as="textarea"
                      className="form-control"
                      id="question"
                      name="question"
                      rows={8}
                      maxLength={300}
                      placeholder="Enter Download Required / Comments"
                    />
                    <ErrorMessage name="question">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                  </div>
                  <p>* Maximum 300 Characters</p>
                </div>

                <div className="col-sm-12 col-lg-12">
                  <div className="proQuestion-btn">
                    <div className="product-button button-effect">
                      <button
                        type="submit"
                        className="btn btn-products btn-addcart"
                        disabled={submitclicked == true && "disabled"}
                      >
                        {submitclicked == true ? (
                          <Fragment>
                            <i className="fas fa-spinner fa-spin"></i> Sending...
                          </Fragment>
                        ) : (
                          "Send Request"
                        )}
                      </button>
                    </div>
                    <div className="product-button">
                      <button
                        type="button"
                        className="btn btn-products btn-unavailable"
                        id="cancelQts-proDownload"
                        onClick={() => handleCancelClick(resetForm)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
